import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-white text-brand-night" data-id="element-88" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-89" data-mp="9tbcosa2cgg6">
        <p className="font-display text-[0.62rem] font-bold uppercase tracking-[0.14em] text-brand-green" data-id="element-90" data-mp="et67v80vfs71">
          Tu inversión está protegida
        </p>

        <Reveal className="mt-2 flex items-start gap-3 rounded-xl border-2 border-brand-green bg-[#EAF7F0] p-3 text-left" data-id="element-91" data-mp="jsafhu85dhv9">
          <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-brand-green" data-id="element-92" data-mp="skugh1bwvyj9">
            <ShieldCheckIcon size={20} className="text-white" data-id="element-93" data-mp="xjnuqvz0vtkh" />
          </span>
          <div data-id="element-94" data-mp="xlrzth8nqymc">
            <h2 id="garantia" className="font-display text-sm font-extrabold uppercase leading-tight sm:text-base" data-id="element-95" data-mp="12ja958ql7fuv">
              🛡️ Garantía total de 7 días
            </h2>
            <p className="mt-0.5 text-[0.78rem] leading-snug text-brand-night/75" data-id="element-96" data-mp="25s6zud2lb55q">
              Tienes 7 días para explorar los 6 tomos y los 5 bonos. Si
              consideras que el sistema no es adecuado para ti, puedes
              solicitar un reembolso dentro del período establecido según los
              términos de devolución.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}